import React from 'react';
import Container from './Logo.style';

function Logo() {
  return (
    <Container>
      Where in the world?
    </Container>
  );
}

export default Logo;